import api from '@/utils/api/index'
import * as types from '~/store/mutation-types'

export const state = () => ({ categories: {} })

export const getters = { categories: state => state.categories }

export const actions = {
  async requestCategories({ commit }) {
    const { data } = await this.$axios.get(api.categories.getCategories())

    commit(types.SET_CATEGORIES, data)

    return data
  },

  async requestVote(_, { payload }) {
    await this.$axios.post(api.categories.vote(), payload)
  }
}

export const mutations = {
  [types.SET_CATEGORIES](state, categories) {
    state.categories = categories
  }
}
